import MockAdapter from 'axios-mock-adapter';
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { baseUrl, mockUserToken, useMock } from '../Configuration';
import { getUserToken, handleUnauthorized } from './AuthService';

export const api = axios.create({
  baseURL: baseUrl,
});

function authorizationInterceptor(
  request: InternalAxiosRequestConfig<any>,
): InternalAxiosRequestConfig<any> {
  const userToken = getUserToken();

  if (userToken) {
    request.headers.Authorization = `BEARER ${userToken}`;
  }

  if (mockUserToken === 'true') {
    request.headers['X-Partner-Code'] = '0000';
    request.headers['X-Partner-Name'] = 'Partner';
  }

  return request;
}

function unauthorizedInterceptor(
  error: AxiosError,
): void {
  if (error.response?.status !== 401) {
    throw error;
  }

  // For some reason cannot access message. Using ts-ignore for now.
  // Will be hopefully resolved in distant future.
  // @ts-ignore
  handleUnauthorized(error.response?.data?.message ?? error.message);
}

api.interceptors.request.use(authorizationInterceptor);
api.interceptors.response.use((response) => response, unauthorizedInterceptor);

export const mock = new MockAdapter(api, { delayResponse: 500 });

if (useMock !== 'true') {
  mock.restore();
}
